export default function TitleView(props) {
  return (
    <div className={props.className}>
      <h1 className="display-3 text-break">{props.title}</h1>
      {props.subtitle && <p className="lead text-secondary">{props.subtitle}</p>}
    </div>
  );
}
